import { getConfiguration } from '@api/config';
import * as api from '@api/global';

import { makeApiActionCreatorV3 } from './utils';

export const CONFIGURE = 'CONFIGURE';
export const WARNING = 'WARNING';
export const START = 'START';
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const GEOCODE_GET_START = 'GLOBAL/GEOCODE_GET_START';
export const GEOCODE_GET_SUCCESS = 'GLOBAL/GEOCODE_GET_SUCCESS';
export const GEOCODE_GET_ERROR = 'GLOBAL/GEOCODE_GET_ERROR';

export const SPACE_OCR_START = 'GLOBAL/SPACE_OCR_START';
export const SPACE_OCR_SUCCESS = 'GLOBAL/SPACE_OCR_SUCCESS';
export const SPACE_OCR_ERROR = 'GLOBAL/SPACE_OCR_ERROR';

export const GOOGLE_OCR_START = 'GLOBAL/GOOGLE_OCR_START';
export const GOOGLE_OCR_SUCCESS = 'GLOBAL/GOOGLE_OCR_SUCCESS';
export const GOOGLE_OCR_ERROR = 'GLOBAL/GOOGLE_OCR_ERROR';

export const RECORD_START = 'RECORD_START';
export const RECORD_STOP = 'RECORD_STOP';

export const TOGGLE_PAGE_MENU = 'TOGGLE_PAGE_MENU';

export const OFFICES_FETCH_START = 'OFFICES_FETCH_START';
export const OFFICES_FETCH_SUCCESS = 'OFFICES_FETCH_SUCCESS';
export const OFFICES_FETCH_ERROR = 'OFFICES_FETCH_ERROR';

export const LAST_RECALC_STATUS_FETCH_START = 'LAST_RECALC_STATUS_FETCH_START';
export const LAST_RECALC_STATUS_FETCH_SUCCESS =
  'LAST_RECALC_STATUS_FETCH_SUCCESS';
export const LAST_RECALC_STATUS_FETCH_ERROR = 'LAST_RECALC_STATUS_FETCH_ERROR';

export const USERS_FETCH_START = 'USERS_FETCH_START';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USERS_FETCH_ERROR = 'USERS_FETCH_ERROR';

export const FETCH_USER_STATUS_START = 'FETCH_USER_STATUS_START';
export const FETCH_USER_STATUS_SUCCESS = 'FETCH_USER_STATUS_SUCCESS';
export const FETCH_USER_STATUS_ERROR = 'FETCH_USER_STATUS_ERROR';

export const UPDATE_USER_STATUS_START = 'UPDATE_USER_STATUS_START';
export const UPDATE_USER_STATUS_SUCCESS = 'UPDATE_USER_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_ERROR = 'UPDATE_USER_STATUS_ERROR';

export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

export const fetchUserStatus = makeApiActionCreatorV3(
  api.fetchUserStatus,
  FETCH_USER_STATUS_START,
  FETCH_USER_STATUS_SUCCESS,
  FETCH_USER_STATUS_ERROR,
);

export const updateUserStatus = makeApiActionCreatorV3(
  api.updateUserStatus,
  UPDATE_USER_STATUS_START,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_ERROR,
);

export const fetchOffices = makeApiActionCreatorV3(
  api.fetchOffices,
  OFFICES_FETCH_START,
  OFFICES_FETCH_SUCCESS,
  OFFICES_FETCH_ERROR,
);
export const fetchLastRecalcStatus = makeApiActionCreatorV3(
  api.fetchLastRecalcStatus,
  LAST_RECALC_STATUS_FETCH_START,
  LAST_RECALC_STATUS_FETCH_SUCCESS,
  LAST_RECALC_STATUS_FETCH_ERROR,
);
export const getGeoCode = makeApiActionCreatorV3(
  api.getGeoCode,
  GEOCODE_GET_START,
  GEOCODE_GET_SUCCESS,
  GEOCODE_GET_ERROR,
);
export const startSpaceOcr = makeApiActionCreatorV3(
  api.startSpaceOcr,
  SPACE_OCR_START,
  SPACE_OCR_SUCCESS,
  SPACE_OCR_ERROR,
);
export const startGoogleOcr = makeApiActionCreatorV3(
  api.startGoogleOcr,
  GOOGLE_OCR_START,
  GOOGLE_OCR_SUCCESS,
  GOOGLE_OCR_ERROR,
);
export const fetchUsers = makeApiActionCreatorV3(
  api.fetchUsers,
  USERS_FETCH_START,
  USERS_FETCH_SUCCESS,
  USERS_FETCH_ERROR,
);

export function init() {
  return async (dispatch) => {
    const configuration = await getConfiguration();
    dispatch({ type: CONFIGURE, configuration });
  };
}

export function updateUserStatusFromOutside(data) {
  return async (dispatch) => {
    dispatch({ type: UPDATE_USER_STATUS, data });
  };
}

export function toggleSidebar() {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_SIDEBAR });
  };
}

export function togglePageMenu() {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_PAGE_MENU });
  };
}

export function startRecord() {
  return async (dispatch) => {
    dispatch({ type: RECORD_START });
  };
}

export function stopRecord() {
  return async (dispatch) => {
    dispatch({ type: RECORD_STOP });
  };
}

export function showWarning(message) {
  return async (dispatch) => {
    dispatch({ type: WARNING, error: { body: { warning: message } } });
  };
}

export const showSuccess = (message) => ({
  type: SUCCESS,
  message,
});

export const showError = (message) => ({
  type: ERROR,
  message,
});

export const SET_ROUTE_STATE = `$GLOBAL/SET_ROUTE_STATE`;

export const setRouteState = (key, state = {}) => ({
  type: SET_ROUTE_STATE,
  key: key,
  state: state,
});

export const RESET_ROUTE_STATE = `$GLOBAL/RESET_ROUTE_STATE`;

export const resetRouteState = (key, state = {}) => ({
  type: RESET_ROUTE_STATE,
  key: key,
  state: state,
});
